export enum ChargeOption {
	SUM_TOTAL = { code: 1, description: "PRODUCTS.SUM_TOTAL" } as any,
	HIGHEST_VALUE = { code: 2, description: "PRODUCTS.HIGHEST_VALUE" } as any,
	LOWER_VALUE = { code: 3, description: "PRODUCTS.LOWER_VALUE" } as any,
	AVERAGE = { code: 4, description: "PRODUCTS.AVERAGE" } as any
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/enum/charge-option.enum.ts